import { render, staticRenderFns } from "./EditGuidanceWorkplacePage.vue?vue&type=template&id=d9f8855c&"
import script from "./EditGuidanceWorkplacePage.vue?vue&type=script&lang=js&"
export * from "./EditGuidanceWorkplacePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports